import { OptionItem } from 'tno-core';

export const accountTypeOptions = [
  new OptionItem('Editor', 'editor'),
  new OptionItem('Subscriber', 'subscriber'),
];
